module.exports = __webpack_public_path__ + "img/instalacion-tuberias (1).048cf10a.jpg";